/**
 * Estado vacío de primera vez (diseño Alta.dc.html, pantalla 8).
 *
 * Con self-service TODOS los clientes empiezan en vacío: un "no hay datos"
 * seco es un callejón. Este patrón guía a la acción siguiente.
 */
import { Icon, IconName } from './Icon';

export function EmptyState({
  icon,
  title,
  body,
  ctaLabel,
  onCta,
}: {
  icon: IconName;
  title: string;
  body: string;
  ctaLabel?: string;
  onCta?: () => void;
}) {
  return (
    <div className="bg-surface border border-line rounded-2xl px-6 py-7 text-center flex flex-col items-center animate-rise">
      <span className="w-[60px] h-[60px] rounded-2xl bg-surface-2 grid place-items-center mb-4 text-ink-2">
        <Icon name={icon} size={26} strokeWidth={1.7} />
      </span>
      <h3 className="font-display font-bold text-[18px] mb-2">{title}</h3>
      <p className="text-[14px] text-ink-2 leading-relaxed mb-5 max-w-[36ch]">{body}</p>
      {ctaLabel && onCta && (
        <button
          onClick={onCta}
          className="h-[46px] px-5 rounded-xl bg-brand text-on-brand font-bold text-[14.5px] flex items-center gap-2"
        >
          <Icon name="plus" size={17} strokeWidth={2} />
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
